import BaseView from "./_BaseView";
import Table from "../components/Table";
import Dropdown from "../components/Dropdown";
import Confirm from "../components/Confirm";
import Api from "../Api";
import Notify from "../components/Notify";
import trans from "../util/trans";

export default class VersionsView extends BaseView {

    init() {
        super.init();
        const self = this;
        const versions = $('#versions');
        if (versions.length > 0) {
            const id = versions.data('id');
            this.table = new Table('versions', `/api/versions/${id}/table`, [
                {data: 'select', orderable: false},
                {data: 'version'},
                {data: 'desc'},
                {data: 'step'},
                {data: 'updated_at'},
                {data: 'tools', orderable: false},
            ]);

            this.menu = new Dropdown('#versionMenu', {
                onDelete: function (ids) {
                    if (ids.length > 0) {
                        Confirm({
                            ok: Lang.delete,
                            title: Lang.deleting,
                            msg: trans('deletexversions', {x: ids.length}),
                            onConfirm: function () {
                                const data = {ids: []};
                                $.each(ids, function (i, row) {
                                    data.ids.push(row);
                                });
                                Api.send(`/api/versions/bulkdelete`, data, 'post').done(function () {
                                    self.table.reload();
                                });
                            }
                        });
                    }
                },
            });
        }
    }

    showDiff(id) {
        Api.getTpl('diff').done(function (r) {
            const tpl = _.template(r);
            Api.send(`/api/versions/${id}/diff`).done(function (d) {
                $('#diff')
                    .empty()
                    .css({
                        height: '100%',
                        opacity: 1
                    }).append(tpl({diff: d}));
                $('body').scrollTop(0);
            });
        });
    }

    renderRestoreCopy(id, title) {
        Api.getTpl('restore-copy-form').done(function (r) {
            const tpl = _.template(r);

            Confirm({
                ok: Lang.save,
                title: Lang.restorecopy,
                msg: tpl({title: `${title} - ${Lang.copy}`}),
                onValidate: function () {
                    return $('#guideForm').isFormValid();
                },
                onConfirm: function () {
                    const data = $('#versionForm').aeroSerialize();

                    Api.send(`/api/versions/${id}/copy`, data, 'post').done(function () {
                        Notify(Lang.restorecopysuccess, 'success');
                    });

                }
            });
        });
    }

    setEvents() {
        super.setEvents();
        const self = this;
        this.container = $('#versionGroup');

        this.container.on('click.diff', '.diff', function () {
            self.showDiff($(this).parents('.tools').data('id'));
        });

        this.container.on('click.versionr', '.restore', function () {
            const id = $(this).parents('.tools').data('id');
            Api.send(`/api/versions/${id}`, {}, 'post').done(function () {
                self.table.reload();
            });
        });

        this.container.on('click.versionr', '.copy', function () {
            const id = $(this).parents('.tools').data('id');
            const title = $('[data-title]').data('title');
            self.renderRestoreCopy(id, title);
        });

        this.container.off('click.versiond').on('click.versiond', '.delete', function () {
            const id = $(this).parents('div:eq(0)').data('id');
            //Confirm
            Confirm({
                ok: Lang.delete,
                title: 'Delete version',
                msg: Lang.delsure,
                onConfirm: function () {
                    Api.send(`/api/versions/${id}`, {}, 'delete').done(function () {
                        self.table.reload();
                    });
                }
            });
            return false;
        });

        $('body').off("click.diffoff").on("click.diffoff", "#diff .close", function () {
            $('#diff')
                .css({
                    height: 0,
                    opacity: 0
                }).empty();
            return false;
        });
    }
}